export default function (_this) {
  return {
    create (propName, callback) {
      _this.getRef('widgetsComputed').child(propName)
        .set('', (snapshot) => (callback()))
    },
    read (callback) {
      _this.getRef('widgetsComputed').on('value', (snapshot) => {
        callback(snapshot.val())
      })
    },
    update (key, prop) {
      _this.getRef('widgetsComputed').child(key)
        .set(prop)
    },
    delete (key, callback) {
      _this.getRef('widgetsComputed').child(key).remove((err) => {
        callback(err)
      })
    }
  }
}
